// A finished action leaves its own page behind it (release 3.3, Back model B9).
//
// After a questionnaire is sent, a decision made or an import committed, the
// form that did it is finished. Moving on with a new history entry left the
// form one Back away, and Back reopened it, ready to be sent again.
//
// When the form was opened from the very page it finishes on (the send screen
// from its vendor, the usual way), finishAt steps back to that page: its
// history entry comes back with its own origin and scroll place, and the form
// is no longer behind it. Otherwise (a form reached by a link) it replaces the
// form's entry with where the person goes next, keeping the origin noted on
// it, so Back from there goes to wherever they were before the form.

import { taskOpenedFrom } from './origin'

export function finishAt(href: string): void {
  if (typeof window === 'undefined') return
  const to = href.startsWith('#') ? href : '#' + href.replace(/^\/?/, '/')
  if (taskOpenedFrom() === to) {
    history.back()
    return
  }
  try {
    const before = window.location.href
    const { k: _k, ...kept } = (history.state ?? {}) as Record<string, unknown>
    history.replaceState(kept, '', to)
    // replaceState raises no event, and the console routes on hashchange
    // (App.tsx), so it is raised here with the address that was left.
    window.dispatchEvent(new HashChangeEvent('hashchange', { oldURL: before, newURL: window.location.href }))
  } catch {
    window.location.replace(to)
  }
}
